import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FilterCheckbox(props) {
  return /*#__PURE__*/_jsxs(UICheckbox, {
    "data-test-id": "filter-checkbox-internal",
    defaultChecked: props.defaultValue,
    onChange: ({
      target: {
        checked
      }
    }) => props.onCheck(checked),
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "filter-checkbox-label",
      message: props.labelLangPath
    }), props.helpLangPath ? /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-left-2",
      "data-test-id": "filter-checkbox-help-icon",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: props.helpLangPath
      }),
      tooltipPlacement: "bottom left"
    }) : null]
  });
}
FilterCheckbox.propTypes = {
  defaultValue: PropTypes.bool,
  helpLangPath: PropTypes.string,
  labelLangPath: PropTypes.string.isRequired,
  onCheck: PropTypes.func.isRequired
};
FilterCheckbox.defaultProps = {
  helpLangPath: '',
  defaultValue: false
};
export default /*#__PURE__*/memo(FilterCheckbox);